import { fetchRequest } from 'src/hooks/useAPIRequest'
import { API_ENDPOINTS } from 'src/routes/routes'

interface Params {
    redirectUrl: string
}

const validateRedirect = async ({ redirectUrl }: Params) => {
    return await fetchRequest<{ valid: boolean }>(`${API_ENDPOINTS.VALIDATE_REDIRECT}?redirect_url=${redirectUrl}`)
}

export default validateRedirect
